<template>
  <section>
    <div class="left">
      <h2 v-translate>Metadata streamu</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <select-box
          id="streamprofileidcodec"
          :required="true"
          v-model="entity.id_codec"
          :options="codecsOptions"
          ref="codecref"
          :disabled="disabled"
        ><translate class="translate">Kodek</translate>
        </select-box>
      </div>
      <div class="field_right">
        <text-input id="streamProfilewidth"
                    :required="true"
                    :disabled="disabled"
                    v-model="entity.resolution.width"
                    ref="widthref"
        >
          <translate class="translate">Šířka</translate>

        </text-input>
      </div>
      <div class="field_left">
        <text-input id="streamProfilebitrate"
                    :required="true"
                    :disabled="disabled"
                    v-model="entity.bitrate"
                    ref="bitrateref"
        >
          <translate class="translate">Bitrate</translate>

        </text-input>
      </div>
      <div class="field_right">
        <text-input id="streamProfileheight"
                    :required="true"
                    :disabled="disabled"
                    v-model="entity.resolution.height"
                    ref="heightref"
        >
          <translate class="translate">Výška</translate>

        </text-input>
      </div>
      <div class="field_left">
        <text-input id="streamProfilebitrateshaping"
                    :disabled="disabled"
                    v-model="entity.shaping_bitrate"
                    ref="shapingbitrateref"
        >
          <translate class="translate">Shapovací bitrate</translate>

        </text-input>
      </div>
      <div class="field_right">
        <checkbox-input
          id="streamprofileinterlaced"
          :disabled="disabled"
          v-model="entity.interlaced"
          ref="interlacedref"
        >
          <translate class="translate">Prokládaný stream</translate>
        </checkbox-input>
      </div>
      <div class="field_right">
        <checkbox-input
            id="streamprofilereadsctemarkers"
            :disabled="disabled"
            v-model="entity.read_scte_markers"
            ref="readsctemarkersdref"
        >
          <translate class="translate">Číst SCTE35 značky</translate>
        </checkbox-input>
      </div>
    </div>
  </section>
</template>

<script>
import TextInput from "@/components/common/TextInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"
import {prepareOptions} from "../../../../utils/helpers";

export default {
  name: "StreamProfileMetadataForm",
  components: {TextInput},
  mixins: [formFilterData, requiredFields],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      codecs: [],
      codecsOptions: [],
    }
  },
  created(CodecService) {
    this.codecService = CodecService;

    this.initCodecOptions().catch((error) => {
        this.setErrorMessage(error['error_message'])
    });
  },
  computed: {
    disabled(){
      return !this.isEditable || !this.$_updateActionAllowed;
    },
  },
  methods: {
    initCodecOptions() {
      return this.codecService.getEntities()
        .then(data => {
          this.codecs = data['codecs']
          this.codecsOptions = prepareOptions(data['codecs'], 'id', 'name')
        })
    },
    validateStreamProfileFormRequiredFields() {
      let widthError = null
      let heightError = null
      let bitrateError = null
      let codecError = null;

      if (!this.entity.resolution.width) {
        widthError = this.$gettext('Zadejte šířku')
      }

      if (!this.entity.resolution.height) {
        heightError = this.$gettext('Zadejte výšku')
      }

      if (!this.entity.bitrate) {
        bitrateError = this.$gettext('Zadejte bitrate')
      }

      if (!this.entity.id_codec) {
        codecError = this.$gettext('Kodek musí být vybrán');
      }

      if (widthError !== null) {
        this.setFieldInvalid('widthref', true, widthError)
      } else {
        this.setFieldInvalid('widthref')
      }

      if (heightError !== null) {
        this.setFieldInvalid('heightref', true, heightError)
      } else {
        this.setFieldInvalid('heightref')
      }

      if (bitrateError !== null) {
        this.setFieldInvalid('bitrateref', true, bitrateError)
      } else {
        this.setFieldInvalid('bitrateref')
      }

      if (codecError !== null) {
        this.setFieldInvalid('codecref', true, codecError)
      } else {
        this.setFieldInvalid('codecref')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/forms/StreamProfileMetadataForm.vue